import toast from "react-hot-toast";

export const reorderTasks = ({
  result,
  filteredTasks,
  tasks,
  setTasks,
  setLocalTodos,
  queryClient,
  updateTodo,
}) => {
  if (filteredTasks) {
    const reorderedData = Array.from(filteredTasks);
    const [reorderedItem] = reorderedData.splice(result.source.index, 1);
    reorderedData.splice(result.destination.index, 0, reorderedItem);
    setLocalTodos(reorderedData);
    queryClient.setQueryData(["todos"], (oldData) => {
      if (!oldData?.data) return oldData;
      return { ...oldData, data: reorderedData };
    });

    const afterId =
      result.destination.index > 0
        ? reorderedData[result.destination.index - 1].id
        : null;

    updateTodo({
      id: reorderedItem.id,
      isMove: true,
      data: {
        after_todo: afterId,
      },
    });
    return;
  }

  const items = Array.from(tasks);
  const [reorderedItem] = items.splice(result.source.index, 1);
  items.splice(result.destination.index, 0, reorderedItem);
  setTasks(items);
};

export const handleCardDropToTasks = ({
  result,
  filteredTasks,
  filteredCards,
  localTodos,
  setLocalTodos,
  setOptimisticTodoId,
  queryClient,
  createTodo,
}) => {
  const { destination, draggableId } = result;

  const sourceCard = filteredCards.find(
    (card) => String(card.card.card_id) === String(draggableId)
  );

  if (!sourceCard) {
    toast.error("Card data not found");
    return;
  }

  const afterId =
    destination?.index > 0 ? filteredTasks[destination.index - 1].id : null;

  const tempId = `temp-${Date.now()}`;
  const optimisticTask = {
    id: tempId,
    title: sourceCard.card.title,
    after_todo: afterId,
    source_id: draggableId,
    due_date: sourceCard.card.due_date || null,
    source_type: "TASKBOARD",
    isOptimistic: true,
  };

  setOptimisticTodoId(tempId);

  const updatedTodos = [...localTodos];
  updatedTodos.splice(destination.index, 0, optimisticTask);
  setLocalTodos(updatedTodos);

  queryClient.setQueryData(["todos"], (oldData) => {
    if (!oldData?.data) return oldData;
    return {
      ...oldData,
      data: updatedTodos,
    };
  });

  createTodo({
    title: sourceCard.card.title,
    after_todo: afterId,
    source_id: draggableId,
    source_type: "TASKBOARD",
    due_date: sourceCard.card.due_date || null,
  });
};

export const handleTaskManagerDragEnd = ({
  result,
  filteredTasks,
  filteredCards,
  tasks,
  setTasks,
  localTodos,
  setLocalTodos,
  setOptimisticTodoId,
  queryClient,
  updateTodo,
  createTodo,
}) => {
  const { source, destination } = result;

  if (!destination) {
    return;
  }

  if (
    source.droppableId === destination.droppableId &&
    source.index === destination.index
  ) {
    return;
  }

  if (
    source.droppableId === destination.droppableId &&
    source.droppableId === "left-tasks"
  ) {
    reorderTasks({
      result,
      filteredTasks,
      tasks,
      setTasks,
      setLocalTodos,
      queryClient,
      updateTodo,
    });
    return;
  }

  if (
    destination.droppableId === "left-tasks" &&
    source.droppableId === "right-tasks"
  ) {
    handleCardDropToTasks({
      result,
      filteredTasks,
      filteredCards,
      localTodos,
      setLocalTodos,
      setOptimisticTodoId,
      queryClient,
      createTodo,
    });
  }
};
